/*global _ */
import {hasSlot} from '../../lib/component'
import {attrs as validationAttrs} from '../../props/validations'
//@note: DesignerMixin is required for component like inputs which do not use Base mixin or Component mixin
import DesignerMixin from '../../designer/mixins'
import HydratorMixin from './hydrator'
const mixins = [DesignerMixin, HydratorMixin]

import ReValidation from '../../components/basic/form/re-validation'
const components = {ReValidation}

export default {
  components,
  mixins,
  data() {
    return {
      innerValueName: 'innerValue',
      innerValue: this.value,
      isDirtyState: this.isDirty || false,
    }
  },

  computed: {
    isReadonly() {
      return !!this.allAttrs.readonly
    },
    isDisabled() {
      return !!this.allAttrs.disabled
    },
    inputAttrs() {
      const items = {
        name: this.name,
        tabindex: this.tabindex,
        disabled: this.isDisabled,
        readonly: this.isReadonly,

        ...this.extraInputAttrs,
        ...this.designerInputAttrs,
      }
      return _.omitBy(_.omit(items, this.omitInputAttrs), v => _.isNil(v))
    },
    designerInputAttrs() {
      if (!this.designerMode) {
        return {}
      }
      return {
        'data-native-element': this.inputType || 'input',
        'data-designer-protected': '1'
      }
    },
    extraInputAttrs() {
      return {
        autocomplete: this.autocomplete || null,
        placeholder: this.placeholder || null,
      }
    },
    omitInputAttrs() {
      return ['required']
    },

    allAttrs() {
      return {...this.$props, ...this.$attrs}
    },

    validationAttrs() {
      return {
        ..._.pick(this.allAttrs, validationAttrs),
        value: this[this.innerValueName || 'innerValue'],
        isDirty: this.isDirtyState,
        tabindex: null
      }
    },
    inputClasses() {
      return [this.inputClass]
    },

    model: {
      get() {
        return this.innerValue
      },
      set(value) {
        this.innerValue = value
        this.$emit('input', value)
      }
    }
  },

  watch: {
    value(newValue) {
      this.innerValue = newValue
    }
  },

  methods: {
    hasSlot,
    onInput(event) {
      this.isDirtyState = true
      if (!this.lazy) {
        this.model = event.target.value
      }
    },
    onChange(event) {
      this.isDirtyState = true
      if (this.lazy) {
        this.model = event.target.value
      }
    },
    onEnter(event) {
      this.$emit('enter', event)
    },
    getLabelExtraClasses() {
      return []
    },
    getDescriptionExtraClasses() {
      return []
    },
    getDescriptionClasses() {
      return [
        're-input-description',
        ...this.getDescriptionExtraClasses(),
      ]
    },
    getLabelClasses() {
      const attr = this.$$attrs() || {}
      return [
        're-input-label',
        ...this.getLabelExtraClasses(),
        {
          required: attr.required
        }
      ]
    },
  }
}

